(() => {
  const gradeText = {
    'C-10':'Mint: all original and unused, with no evidence of handling or wear.',
    'C-9':'Factory new: unused and in factory-new condition.',
    'C-8':'Like new: complete and exceptionally clean, with only minimal evidence of handling.',
    'C-7':'Excellent: all original, with minute evidence of handling and use.',
    'C-6':'Very good: minor scratches and paint nicks; no dents or rust.',
    'C-5':'Good: signs of play wear, minor dents and scratches.',
    'C-4':'Fair: scratched, moderately dirty, dented or showing surface rust.',
    'C-3':'Standard: well worn and may be incomplete, but suitable for restoration.',
    'C-2':'Restoration candidate: substantially worn, damaged or incomplete.',
    'C-1':'Junk: generally usable only for parts.',
    'P-10':'Mint packaging: essentially perfect original packaging.',
    'P-9':'Factory-new packaging: original packaging with negligible handling.',
    'P-8':'Like-new packaging: very clean with only minor handling evidence.',
    'P-7':'Excellent packaging: light wear while remaining sound and presentable.',
    'P-6':'Very good packaging: moderate shelf or handling wear.',
    'P-5':'Good packaging: visible wear, creasing or minor damage.',
    'P-4':'Fair packaging: substantial wear or damage but still serviceable.',
    'P-3':'Poor packaging: heavily worn, damaged or incomplete.',
    'P-2':'Restoration-candidate packaging: severely damaged or fragmentary.',
    'P-1':'Junk packaging: little practical protective or collector value.'
  };

  function removeLiteralDashes(root = document) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const remove = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.textContent.trim() === '-' && node.parentElement?.closest('product-info')) remove.push(node);
    }
    remove.forEach(node => node.remove());
  }

  function enhanceConditionDetails() {
    document.querySelectorAll('[id^="DavidProductDetails-"]').forEach(root => {
      root.querySelectorAll('.dt-detail-list > div').forEach(row => {
        const label = row.querySelector('dt');
        const value = row.querySelector('dd');
        if (!label || !value) return;
        const normalized = label.textContent.trim().toLowerCase();
        if (normalized === 'tca condition') label.textContent = 'TCA Condition';
        if (normalized === 'tca box' || normalized === 'tca box condition' || normalized === 'box condition') label.textContent = 'TCA Box Condition';
        if (!['TCA Condition','TCA Box Condition'].includes(label.textContent.trim())) return;
        const code = value.textContent.match(/[CP]-\d{1,2}/)?.[0];
        if (!code || !gradeText[code] || value.querySelector('.dt-grade-info')) return;
        const info = document.createElement('button');
        info.type = 'button';
        info.className = 'dt-grade-info';
        info.setAttribute('aria-label', `${code}: ${gradeText[code]}`);
        info.setAttribute('data-tooltip', gradeText[code]);
        info.textContent = 'i';
        value.append(' ', info);
      });
      const conditionHeading = root.querySelector('.dt-condition-section h2');
      if (conditionHeading && !conditionHeading.querySelector('a')) {
        const link = document.createElement('a');
        link.href = 'https://www.tcatrains.org/about-tca/grading-standards/';
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.className = 'dt-tca-guidelines-link';
        link.textContent = 'TCA grading standards';
        conditionHeading.append(' ', link);
      }
    });
  }

  function placeComparisonDisclaimer() {
    document.querySelectorAll('.dt-price-comparison-disclaimer').forEach(note => {
      const productInfo = note.closest('product-info');
      const details = productInfo?.querySelector('[id^="DavidProductDetails-"]');
      if (details && note.previousElementSibling !== details) details.after(note);
    });
  }

  function apply() {
    removeLiteralDashes();
    enhanceConditionDetails();
    placeComparisonDisclaimer();
  }
  apply();
  new MutationObserver(apply).observe(document.documentElement, { childList: true, subtree: true });
})();